// js
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { debounce } from 'lodash';
// css
import '../../styles/components/usage/ValueRealizedQuestionForm.scss';


class ValueRealizedQuestionForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      answer: props.answer.answer
    };

    this.saveForm = debounce(() => {
      const { answer, updateAnswer } = this.props;
      updateAnswer(answer.id, this.state.answer);
    }, 2000);

    this.saveForm = this.saveForm.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e) {
    let value = Number(e.target.value);
    if (Math.max(0, Math.min(value, 100)) !== value) return;
    this.setState({answer: value});
    this.saveForm();
  }

  render() {
    const { question: q } = this.props;
    const { answer } = this.state;
    const isAnswered = answer !== null;

    return (
      <div className='value-realized-question-form row'>
        <div className='col-xs-12 col-sm-6'>
          <label className='h6 value-realized-question-form__title'>{ q.title } <span className='hidden'>{answer}</span></label>
        </div>
        <div className='col-xs-12 col-sm-2'>
          <div className='value-realized-question-form__answer'>
            {isAnswered && <i className='icon icon-check-green' />}
            <input type='text' value={isAnswered ? answer : ''} onChange={this.handleChange} ref={`valueRealized${q.id}`} />
            <p className='value-realized-question-form__percent'>%</p>
          </div>
        </div>
        <div className='col-xs-12 col-sm-4'>
          {!!q.low && !!q.high && <p>{`Typically ${q.low * 100}% - ${q.high * 100}%`}</p>}
        </div>
      </div>
    );
  }
}

ValueRealizedQuestionForm.propTypes = {
  question: PropTypes.object,
  answer: PropTypes.object,
  updateAnswer: PropTypes.func
};

export default ValueRealizedQuestionForm;



// WEBPACK FOOTER //
// ./src/components/usage/ValueRealizedQuestionForm.js